import ApiService from '@/data/services/ApiService'
import { IPlayerPosition, IServiceResponse } from '@/data/models'
import { AxiosResponse } from 'axios'

export class PlayerPositionApiService extends ApiService {
  static async getAll(params: object): Promise<IServiceResponse<IPlayerPosition[]>> {
    return this.axios.get('player-positions', { params })
      .then((response: AxiosResponse<IServiceResponse<IPlayerPosition[]>>) => response.data)
  }
}
